// @ts-ignore
import * as MouseTrap from 'mousetrap';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import HIDEvent from '../_events/HIDEvent';

const TargetedKeys = ["wheel", "leftclick", "middleclick", "rightclick"]

const HIDContainer = (Base:React.ComponentType<any>, HIDEvents:Array<HIDEvent>) => {
	type ContainerProps = {
		hidEvent?: Function
	}

	class Container extends React.Component<ContainerProps> {
		private ref:React.RefObject<any>;

		constructor(props:ContainerProps){
			super(props);
			this.ref = React.createRef();
		}

		componentDidMount(){
			HIDEvents.forEach((event) => {
				const element = TargetedKeys.indexOf(event.key) !== -1 ? this.ref.current : document;
				MouseTrap(element).bind(
					event.key,
					(e:HIDEvent) => this.props.hidEvent(e, event.callback, event.repeat || false),
					event.type
				)
			})
		}

		componentWillUnmount(){
			HIDEvents.forEach((event) => MouseTrap.unbind(event.key))
		}

		render() {
			return <div className="HIDContainer" ref={this.ref}><Base {...this.props} /></div>
		}
	}

	const mapDispatchToProps = (dispatch:Dispatch, props:ContainerProps) => ({
		hidEvent: (e:KeyboardEvent | MouseEvent | WheelEvent, callback:Function, repeat:Boolean) => {
			if(e instanceof KeyboardEvent){
				e.preventDefault();
				e.stopPropagation();
				if(!repeat && e.repeat) return false
			}
			return callback(e, dispatch);
		}
	});

	return connect(
		null,
		mapDispatchToProps
	)(Container);
}

export default HIDContainer